import { useState } from "react";
import { Table, Tag, Space, Row, Button, Col, Input, Form, Select, Typography } from "antd";
import { ControlOutlined, ReloadOutlined } from "@ant-design/icons";

const UserList = () => {
  const [form] = Form.useForm();

  const [showFilters, setShowFilters] = useState(false);

  const onSearch = (value) => {
    console.log(value);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Tags",
      key: "tags",
      dataIndex: "tags",
      render: (tags) => (
        <>
          {tags.map((tag) => {
            let color = tag.length > 5 ? "geekblue" : "green";
            if (tag === "loser") {
              color = "volcano";
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          delete
        </Space>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      tags: ["nice", "developer"],
    },
    {
      key: "2",
      name: "Jim Green",
      age: 42,
      address: "London No. 1 Lake Park",
      tags: ["loser"],
    },
    {
      key: "3",
      name: "Joe Black",
      age: 32,
      address: "Sidney No. 1 Lake Park",
      tags: ["cool", "teacher"],
    },
  ];
  return (
    <div>
      <div className="center">
        <Typography.Title level={2}>User List</Typography.Title>
      </div>
      <Button type="primary" icon={<ControlOutlined />} onClick={() => setShowFilters(!showFilters)}>
        Filter
      </Button>

      {showFilters && (
        <>
          <Button danger icon={<ReloadOutlined />} className="ml-1 mb-1">
            Reset
          </Button>

          <Form onFinish={onSearch} form={form} layout="vertical" className="mb-2">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Form.Item name="medicalSchool" label="Medical School">
                  <Select>
                    <Select.Option></Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="subscriptionPlan" label="Subscription Plan">
                  <Select>
                    <Select.Option></Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="residency" label="Residency">
                  <Select>
                    <Select.Option></Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="country" label="Country">
                  <Select>
                    <Select.Option></Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <div className="center">
              <Button type="primary" htmlType="submit">
                Filter Information
              </Button>
            </div>
          </Form>
        </>
      )}

      {!showFilters && (
        <Row justify="end">
          <Col xs={24} md={12} lg={8}>
            <Input.Search placeholder="Search" enterButton />
          </Col>
        </Row>
      )}

      <Row className="mt-1">
        <Col xs={24}>
          <Table columns={columns} dataSource={data} />
        </Col>
      </Row>
    </div>
  );
};

export default UserList;
